// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Trace point IDs — uint16 enum. 2 bytes on wire, covers all ~140 points.
 */
export enum TracePointId {
  WvsListenerBound = 0,
  WvsVtsConnected = 1,
  WvsHandshakeStarted = 2,
  WvsHandshakeStep = 3,
  WvsHandshakeFinished = 4,
  WvsPacketSent = 5,
  WvsRawBytesSent = 6,
  WvsConfiguredPacketSent = 7,
  WvsBytesReceived = 8,
  WvsPacketCompared = 9,
  WvsRegexMatched = 10,
  WvsPcapPassStarted = 11,
  WvsPacketFiltered = 12,
  WvsPcapPacketSent = 13,
  WvsPcapPassFinished = 14,
  WvsSpoofModeStarted = 15,
  WvsSpoofModeStopped = 16,
  WvsMessageInjected = 17,
  WvsVendorConnectionAccepted = 18,
  WvsAuthHandshake = 19,
  WvsModbusInbound = 20,
  WvsGenericDecode = 21,
  WvsInjectedForwarded = 22,
  WvsSessionCommandRecorded = 23,
  WvsSessionEventRecorded = 24,
  VtsVendorBytesReceived = 100,
  VtsProtocolDecode = 101,
  VtsFemProduced = 102,
  VtsBitmaskDedupCheck = 103,
  VtsOneHotDedupCheck = 104,
  VtsStateMapReplayed = 105,
  VtsStateMapCleared = 106,
  VtsDebounceSubmitted = 107,
  VtsDebounceSuperseded = 108,
  VtsDebounceCancelled = 109,
  VtsDebounceEmitted = 110,
  VtsFemSerialized = 111,
  VtsSentToEdge = 112,
  VtsEdgeReconnect = 113,
  VtsMessageQueued = 114,
  VtsBatchEmitted = 115,
  VtsSentToCloud = 116,
  VtsOAuthTokenRefreshed = 117,
  VtsQuestDbRowConverted = 118,
  VtsQuestDbFlushed = 119,
  VtsQuestDbConnected = 120,
  VtsUiCmdReceivedFromEdge = 121,
  VtsUiCmdReceivedFromWs = 122,
  VtsHttpCommandReceived = 123,
  VtsUiCmdWrappedAsFem = 124,
  VtsVendorBytesProduced = 125,
  VtsDerivedStepSent = 126,
  VtsDerivedResponseReceived = 127,
  VtsDerivedTimeout = 128,
  VtsVendorConnected = 129,
  VtsVendorDisconnected = 130,
  VtsVendorDispatched = 131,
  VtsInstanceSpawned = 132,
  VtsCdoReceived = 133,
  VtsCarMapNormalized = 134,
  VtsHeartbeatSent = 135,
  VtsBacnetReceived = 136,
  VtsBacnetSent = 137,
  VtsStartup = 138,
  VtsShutdown = 139,
  EdgeVtsTcpConnected = 200,
  EdgeFemBytesReceived = 201,
  EdgeFemUnpacked = 202,
  EdgeBatchProcessed = 203,
  EdgeRecordMapUpdated = 204,
  EdgeRecordMapStats = 205,
  EdgeLocalWsBroadcast = 206,
  EdgeCloudWsSend = 207,
  EdgeCloudWsReconnect = 208,
  EdgeRecordMapReplayed = 209,
  EdgeTcpBufferDiagnostic = 210,
  EdgeUiCmdForwarded = 211,
  EdgeCloudCommandReceived = 212,
  EdgeChannelsLoaded = 213,
  EdgeCdosGenerated = 214,
  EdgeDashboardConnected = 215,
  EdgeDashboardDisconnected = 216,
  EdgeBootstrap = 217,
  CloudEdgeServerConnected = 300,
  CloudEdgeMessageReceived = 301,
  CloudFemUnpacked = 302,
  CloudRecordMapUpdated = 303,
  CloudFrontendWsBroadcast = 304,
  CloudHeartbeatBroadcast = 305,
  CloudUiCmdFromDashboard = 306,
  CloudUiCmdRoutedToEdge = 307,
  CloudUiCmdUnpacked = 308,
  CloudEdgeServerDisconnected = 309,
  CloudNotificationSpawned = 310,
  CloudNotificationProcessed = 311,
  CloudJwtValidated = 312,
  CloudEdgeServerValidated = 313,
  CloudAdapterCreated = 314,
  CloudBankCreated = 315,
  CloudChannelCreated = 316,
  CloudDisconnectionBroadcast = 317,
  CloudRecordMapCollected = 318,
  CloudEdgePoolStats = 319,
  CloudDashPoolStats = 320,
  FrontendWsConnectAttempt = 400,
  FrontendWsConnected = 401,
  FrontendWsDisconnected = 402,
  FrontendWsMessageReceived = 403,
  FrontendEnvelopeStripped = 404,
  FrontendBatchDecoded = 405,
  FrontendFemDecoded = 406,
  FrontendDebounceKeyComputed = 407,
  FrontendDeltaApplied = 408,
  FrontendStateChanged = 409,
  FrontendFaultTimerEvent = 410,
  FrontendRafScheduled = 411,
  FrontendRafFlushed = 412,
  FrontendContextMerged = 413,
  FrontendUiCmdBuilt = 414,
  FrontendUiCmdSent = 415,
  FrontendDecodeError = 416,
  FrontendDebounceOverrideUpdate = 417,
  FrontendDirectionDebounce = 418,
  FrontendInitialBatch = 419,
  DiligentConnected = 500,
  DiligentJsonReceived = 501,
  DiligentToFemTranslated = 502,
  DiligentFemToJsonTranslated = 503,
  DiligentHeartbeatSent = 504,
  DiligentError = 505,
  NyctPosterStarted = 510,
  NyctEventExtracted = 511,
  NyctBatchPosted = 512,
  NyctRetryTriggered = 513,
  NyctReceiverLagged = 514,
  NyctQueueConsumed = 515,
  NyctGoApiCall = 516,
  NyctQueueError = 517,
  IntegratorTestStarted = 600,
  IntegratorTestCompleted = 601,
  IntegratorAssertionResult = 602,
  IntegratorQuestDbQuery = 603,
  IntegratorSpoofInjected = 604,
  IntegratorUiCmdSent = 605,
}
